/**
 * Financial Health Score (0–100)
 *
 * 5 weighted factors:
 * - Savings rate     30%
 * - Housing ratio    25%
 * - Debt-to-income   20%
 * - Emergency fund   15%
 * - Income diversity  10%
 */

function scoreSavingsRate(rate) {
  if (rate >= 20) return 100;
  if (rate >= 10) return 70;
  if (rate >= 5) return 50;
  if (rate > 0) return 30;
  return 0;
}

function scoreHousingRatio(ratio) {
  if (ratio <= 25) return 100;
  if (ratio <= 30) return 80;
  if (ratio <= 35) return 60;
  if (ratio <= 40) return 40;
  if (ratio <= 50) return 20;
  return 0;
}

function scoreDebtToIncome(ratio) {
  if (ratio <= 0) return 100;
  if (ratio <= 10) return 85;
  if (ratio <= 20) return 70;
  if (ratio <= 30) return 50;
  if (ratio <= 40) return 30;
  return 10;
}

function scoreEmergencyFund(months) {
  if (months >= 6) return 100;
  if (months >= 3) return 75;
  if (months >= 1) return 50;
  if (months > 0) return 25;
  return 0;
}

function scoreIncomeDiversity(sourceCount) {
  if (sourceCount >= 3) return 100;
  if (sourceCount >= 2) return 70;
  if (sourceCount >= 1) return 40;
  return 0;
}

export function calculateHealthScore({
  savingsRate,
  housingRatio,
  debtToIncomeRatio,
  emergencyFundMonths,
  incomeSourceCount,
}) {
  const savings = scoreSavingsRate(savingsRate) * 0.3;
  const housing = scoreHousingRatio(housingRatio) * 0.25;
  const debt = scoreDebtToIncome(debtToIncomeRatio) * 0.2;
  const emergency = scoreEmergencyFund(emergencyFundMonths) * 0.15;
  const diversity = scoreIncomeDiversity(incomeSourceCount) * 0.1;

  return Math.round(savings + housing + debt + emergency + diversity);
}

export function healthScoreLabel(score, t) {
  if (score >= 80) return t('budgetPlanner.health.excellent', 'Excelente');
  if (score >= 60) return t('budgetPlanner.health.good', 'Bueno');
  if (score >= 40) return t('budgetPlanner.health.fair', 'Regular');
  if (score >= 20) return t('budgetPlanner.health.needsWork', 'Necesita mejoras');
  return t('budgetPlanner.health.critical', 'Crítico');
}

export function healthScoreColor(score) {
  if (score >= 60) return '#2E7D32';   // success
  if (score >= 30) return '#F9A825';   // warning
  return '#C62828';                     // error
}
